import * as React from 'react';
import type { TemplateCategory, TemplateCategoryComponent} from '@/types';
import {QtySelector} from '@/components/atoms/QtySelector.tsx';
import {getMaxQty } from '@/components/helpers/configuratorHelpers.ts';
import { DiffPrice } from '@/components/atoms/DiffPrice';

interface SystemConfiguratorCategoryProps {
  category: TemplateCategory
  setOption: (componentId: string, categoryId: string) => () => void
  setQty: (componentId: string) => (qty: number) => void
}

export default function SystemConfiguratorCategory(props: SystemConfiguratorCategoryProps): React.ReactElement | null {
  const getManufacturerName = (component: TemplateCategoryComponent): string => {
    return component?.product?.manufacturer?.name || '';
  }

  if(props.category.components.length) {
    const maxQty = getMaxQty(props.category);
    return(
      <div className="mt-4">
        <h3 className="text-2xl">{props.category.category.name}</h3>
        <ul className="configurator-options-list">
          { props.category.components.map(component => {
              const manufacturerName = getManufacturerName(component);
              if(component.isSelected === true) {
                return(<li className="configuration-options-list-is-selected">
                  {manufacturerName} {component.product.description}
                  <div>{component.comments}</div>
                </li>)
              }
              return(<li onClick={props.setOption(component._id, props.category._id)} key={component._id}>
                {manufacturerName} {component.product.description}
                <DiffPrice priceAsString={component.displayDiffPrice} />
              </li>)
            })
          }
        </ul>
        <div className="mt-5">
          <QtySelector setQty={props.setQty(props.category._id)} qty={props.category.qty} maxQty={maxQty} />
        </div>
        <div className="mt-5">
          { props.category.comments }
        </div>
      </div>
    )
  }
  return null;
}
